import React, { Fragment, useCallback, useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import httpClient from "httpClient";
import axios from "axios";

export default function Upload({
  onUploadSuccess,
  onUploadError,
  canUploadFile,
  accept, // array of accepted types eg ['.csv','.jpeg','.jpg']
  onFileSelect,
  className='',
  maxSizeMB = 5,
  multiple = false, //no handling for multiple files yet
  label = "Upload File",
}) {

  const acceptProp = accept.map(ext => "."+ext.toLowerCase()).join(",");

  const [files, setFiles] = useState(null);
  const [error, setError] = useState([]);
  const fileInputRef = useRef(null);

  const handleFileChange = (e) => {
    setError([]);
    const files = Array.from(e.target.files);
    const errs = [];
    console.log(files);
    // Validation
    const validFiles = files.filter(file => {
      
      if (file.size > maxSizeMB * 1024 * 1024) {
        errs.push(`"${file.name}" exceeds ${maxSizeMB} MB`);
        return false;
      }
      console.log(file.type)
      const fileExt = file.name.split(".").pop().toLowerCase();
      if (!accept.map(ext => ext.toLowerCase()).includes(fileExt)) {
        errs.push(`File ${file.name} has invalid type`);
        return false;
      }
      return true;
    });

    setError(errs);

    if (validFiles.length > 0) {
      setFiles(validFiles)
      onFileSelect();
    }

    

    // Reset input so the same file can be re-selected
    // e.target.value = "";
  };

  const uploadFile = useCallback(async () => {
    console.log("uploadFile");
    if(!canUploadFile) {
      console.log("!canUploadFile");
      return false
    }
    if(!files || !Array.isArray(files) || files.length === 0) {
      console.log("falsey files");
      return false;
    }
    for(let i=0;i<files.length;i++) {
      const file = files[i];
      if(!file.name || file.name === "") {
            return;
        }
        // setFileUploading(true);
        const response = await httpClient.get(`/risk/v1/getUploadURL?filename=${file.name}`);

        try {
            //TODO find why httpClient.put() did not work
            // await httpClient.put(response.uploadURL,file,{ 
            //   'Content-Type': "multipart/form-data" 
            // });
            await axios({
                method: "put",
                url: response.uploadURL,
                data: file,
                headers: { 'Content-Type': "multipart/form-data" },
            });
            // setFileUploading(false);
            // setFileUploaded(true)
            onUploadSuccess(response.Key);
        } catch(error) {
            
            onUploadError(response, error);
        } finally {
            // setFileUploading(false);
        }
    }

    if(fileInputRef && fileInputRef.current) {
      fileInputRef.current.value="";
    }
    

    setFiles([]);
  },[canUploadFile, files, onUploadSuccess, onUploadError])

  useEffect(()=>{
    uploadFile()
  },[uploadFile])

  return (
    <Fragment>
      <input
        type="file"
        accept={acceptProp}
        multiple={multiple}
        style={{}}
        onChange={handleFileChange}
        disabled={canUploadFile}
        ref={fileInputRef}
        className={className}
      />
      {
        error && <div>{error}</div>
      }
    </Fragment>
  );
}

Upload.propTypes = {
  onFileSelect: PropTypes.array.isRequired,
  onUploadSuccess: PropTypes.func.isRequired,
  onUploadError: PropTypes.func.isRequired,
  canUploadFile: PropTypes.bool.isRequired,
  accept: PropTypes.string.isRequired,
  maxSizeMB: PropTypes.number,
  multiple: PropTypes.bool,
  label: PropTypes.string,
  className: PropTypes.string,
};
